var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.index != -1
        ? _c(
            "v-snackbar",
            {
              staticStyle: { "z-index": "9999 !important" },
              attrs: {
                top:
                  _vm.notifications[_vm.index] &&
                  _vm.notifications[_vm.index].position == "top",
                bottom:
                  _vm.notifications[_vm.index] &&
                  !_vm.notifications[_vm.index].position,
                right:
                  _vm.notifications[_vm.index] &&
                  (!_vm.notifications[_vm.index].position ||
                    _vm.notifications[_vm.index].position == "bottom")
                    ? "right"
                    : false,
                "multi-line":
                  _vm.notifications[_vm.index] &&
                  _vm.notifications[_vm.index].multiLine
                    ? _vm.notifications[_vm.index].multiLine
                    : false,
                timeout:
                  _vm.notifications[_vm.index] &&
                  _vm.notifications[_vm.index].timeout
                    ? _vm.notifications[_vm.index].timeout
                    : 6000,
                color:
                  _vm.notifications[_vm.index] &&
                  _vm.notifications[_vm.index].color
                    ? _vm.notifications[_vm.index].color
                    : "black"
              },
              model: {
                value: _vm.showSnackBar,
                callback: function($$v) {
                  _vm.showSnackBar = $$v
                },
                expression: "showSnackBar"
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.notifications[_vm.index]
                      ? _vm.notifications[_vm.index].message
                      : ""
                  ) +
                  "\n    "
              ),
              _vm.index != -1 &&
              _vm.notifications[_vm.index].color &&
              !_vm.notifications[_vm.index].type == "collections"
                ? _c(
                    "v-btn",
                    {
                      attrs: { flat: "", "white--text": "" },
                      on: {
                        click: function($event) {
                          return _vm.actionNotification()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.notifications[_vm.index]
                              ? _vm.notifications[_vm.index].action.text
                              : ""
                          ) +
                          "\n      "
                      ),
                      _vm.index != -1
                        ? _c(
                            "span",
                            [
                              _vm.notifications[_vm.index].context == "success"
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "white", right: "" } },
                                    [_vm._v("check_circle")]
                                  )
                                : _vm.notifications[_vm.index].context == "info"
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "white", right: "" } },
                                    [_vm._v("info")]
                                  )
                                : _vm.notifications[_vm.index].context ==
                                  "warning"
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "white", right: "" } },
                                    [_vm._v("warning")]
                                  )
                                : _vm.notifications[_vm.index].context ==
                                  "error"
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "white", right: "" } },
                                    [_vm._v("error")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.index != -1 &&
              _vm.notifications[_vm.index].color &&
              _vm.notifications[_vm.index].type == "collections"
                ? _c(
                    "v-btn",
                    {
                      attrs: { flat: "", "white--text": "" },
                      on: {
                        click: function($event) {
                          return _vm.fermeSnackBar()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.notifications[_vm.index]
                              ? _vm.notifications[_vm.index].action.text
                              : ""
                          ) +
                          "\n      "
                      ),
                      _vm.index != -1
                        ? _c(
                            "span",
                            [
                              _vm.notifications[_vm.index].context == "success"
                                ? _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("check_circle")
                                  ])
                                : _vm.notifications[_vm.index].context == "info"
                                ? _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("info")
                                  ])
                                : _vm.notifications[_vm.index].context ==
                                  "warning"
                                ? _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("warning")
                                  ])
                                : _vm.notifications[_vm.index].context ==
                                  "error"
                                ? _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("error")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.index != -1 && !_vm.notifications[_vm.index].color
                ? _c(
                    "v-btn",
                    {
                      class: _vm.notifications[_vm.index].context + "--text",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.actionNotification()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.notifications[_vm.index]
                              ? _vm.notifications[_vm.index].action.text
                              : ""
                          ) +
                          "\n      "
                      ),
                      _vm.index != -1
                        ? _c(
                            "span",
                            [
                              _vm.notifications[_vm.index].context == "success"
                                ? _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("check_circle")
                                  ])
                                : _vm.notifications[_vm.index].context == "info"
                                ? _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("info")
                                  ])
                                : _vm.notifications[_vm.index].context ==
                                  "warning"
                                ? _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("warning")
                                  ])
                                : _vm.notifications[_vm.index].context ==
                                  "error"
                                ? _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("error")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-536bc85a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-536bc85a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzNotifier.vue
// module id = null
// module chunks = 